import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
var store = new Vuex.Store({// store对象  实例化vueX对象
  state: {
    menuid: 15,
    menuname: ''
  },
  mutations: {
    setMenuid: (state, value) => {
      state.menuid = value
    },
    setMenuname: (state, value) => {
      state.menuname = value
    }
  },
  get: {
    getMenuid: state => state.menuid,
    getMenuname: state => state.menuname
  },
  actions: {
    setMenuid (context) {
      context.commit('setMenuid')
    },
    setMenuname (context) {
      context.commit('setMenuname')
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js